module.exports = __webpack_public_path__ + "static/images/img_teacher.ab1ed8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/register/img_teacher.svg
// module id = 1282
// module chunks = 0